<template>
	<div class="col-lg-3 col-sm-12">
		<container-edit-modal
				v-if="spawnEditModal"
				v-model="showEditModal"
				:initial-container-name="record.fieldData['Container Name']"
				:initial-pallet="record.fieldData['Pallet']"
				:initial-container-type="record.fieldData['Container Type']"
				:initial-gross-uo-m="record.fieldData['Gross UoM']"
				:initial-package-weight="record.fieldData['Package Weight']"
				:initial-net-weight="record.fieldData['Net Weight']"
				:id="record.fieldData['Container_PK_ID']"
		></container-edit-modal>
		<div class="card">
			<div class="card-header pt-2 pb-2">
				<span>Container Info</span>
			</div>
			<div v-show="accessPrivileges.includes('CREATE_CONTAINER') && !locked" class="list-group list-group-flush">
				<div class="list-group-item pt-1 pb-1">
					<a href="#" @click.prevent="displayEditModal">Edit <font-awesome-icon icon="edit"></font-awesome-icon></a>
<!--					<router-link :to="{ name: 'container-edit', params: { id: recordId }}" v-show="!locked" replace>
						Edit
						<font-awesome-icon icon="edit"></font-awesome-icon>
					</router-link>-->
				</div>
			</div>
			<div class="card-body">
				<div class="row job-row">
					<div class="col-12">
						<div><strong>Container Name</strong></div>
						<div class="job-field">{{ record.fieldData['Container Name'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Pallet</strong></div>
						<div class="job-field">{{ record.fieldData.Pallet }}</div>
					</div>
					<div class="col-12">
						<div><strong>Type</strong></div>
						<div class="job-field">{{ record.fieldData['Container Type'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Pkg Wt</strong></div>
						<div class="job-field">{{ record.fieldData['Package Weight'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Net Wt</strong></div>
						<div class="job-field">{{ record.fieldData['Net Weight'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Gross Wt</strong></div>
						<div class="job-field">{{ record.fieldData['Gross Weight'] }}</div>
					</div>
					<div class="col-12">
						<div><strong>Gross UoM</strong></div>
						<div class="job-field">{{ record.fieldData['Gross UoM'] }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseView from '../BaseView'
import ContainerEditModal from "@/components/ContainerEditModal";
import {EventBus} from "@/event-bus";

export default {
	name: "ContainerView",
	components: {ContainerEditModal},
	extends: BaseView,
	data() {
		return {
			showEditModal: false,
			spawnEditModal: false,
		}
	},
	methods: {
		displayEditModal() {
			this.showEditModal = true
			this.spawnEditModal = true
		}
	}
}
</script>